import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import {
  createSegmentFailed,
  createSegmentSuccess,
  deleteSegmentFailed,
  deleteSegmentSuccess,
  getGroupsFailed,
  getGroupsSuccess,
  getSegmentsFailed,
  getSegmentsSuccess,
  getSegmentsWatcher,
  getVariablesFailed,
  getVariablesSuccess,
  updateSegmentFailed,
  updateSegmentSuccess,
  getTemplateSegmentCollaboratorsSuccess,
  getTemplateSegmentCollaboratorsFailed,
  uploadTemplateSegmentCollaboratorsFailed,
  uploadTemplateSegmentCollaboratorsSuccess,
} from "./actions"
import {
  GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
  CREATE_SEGMENT_WATCHER,
  DELETE_SEGMENT_WATCHER,
  GET_GROUPS_WATCHER,
  GET_SEGMENTS_WATCHER,
  GET_VARIABLES_WATCHER,
  UPDATE_SEGMENT_WATCHER,
} from "./constants"
import { LOCAL_TOKEN, LOCAL_COMPANY_ID } from "../../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

export function getVariablesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segment-variables`,
  })
}

export function getGroupsApi(variable_id) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segment-variables/groups/${variable_id}`,
  })
}

export function getSegmentsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments`,
  })
}

export function createSegmentApi(params) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments`,
    data: params,
  })
}

export function updateSegmentApi(params) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments/${params.id_segment}`,
    data: params,
  })
}

export function deleteSegmentApi(params) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments/${params}`,
  })
}

export function* getVariablesSaga() {
  try {
    const { data, status } = yield call(getVariablesApi)
    if (status === 200) {
      yield put(getVariablesSuccess(data.data))
    }
  } catch (error) {
    yield put(getVariablesFailed())
    returnMessage(error)
  }
}

export function* getSegmentsSaga() {
  try {
    const { data, status } = yield call(getSegmentsApi)
    if (status === 200) {
      yield put(getSegmentsSuccess(data.data))
    }
  } catch (error) {
    yield put(getSegmentsFailed())
    returnMessage(error)
  }
}

export function* getGroupsSaga(action) {
  try {
    const { data, status } = yield call(getGroupsApi, action.payload)
    if (status === 200) {
      yield put(getGroupsSuccess(data.data))
    }
  } catch (error) {
    yield put(getGroupsFailed())
    returnMessage(error)
  }
}

export function* createSegmentSaga(action) {
  try {
    const { data, status } = yield call(createSegmentApi, action.payload)
    if (status === 201 && data.data) {
      yield call(messageSuccess, data.data.msj)
      yield put(createSegmentSuccess())
    } else {
      yield call(messageFailed, "Error al crear el segmento.")
      yield put(createSegmentFailed())
    }
  } catch (error) {
    yield call(messageFailed, "Error al crear el segmento.")
    yield put(createSegmentFailed())
  }
}

export function* updateSegmentSaga(action) {
  try {
    const { data, status } = yield call(updateSegmentApi, action.payload)
    if (status === 200 && data.data) {
      yield call(messageSuccess, data.data.msj)
      yield put(updateSegmentSuccess())
    } else {
      yield call(messageFailed, "Error al guardar cambios.")
      yield put(updateSegmentFailed())
    }
  } catch (error) {
    yield call(messageFailed, "Error al guardar cambios.")
    yield put(updateSegmentFailed())
  }
}

export function* deleteSegmentSaga(action) {
  try {
    const { data, status } = yield call(deleteSegmentApi, action.payload)
    if (status === 200) {
      yield call(messageSuccess, data.data.msj)
      yield put(deleteSegmentSuccess())
    } else {
      yield call(messageFailed, "Error al eliminar segmento.")
      yield put(deleteSegmentFailed())
    }
  } catch (error) {
    yield call(messageFailed, "Error al eliminar segmento.")
    yield put(deleteSegmentFailed())
  }
}

// GET COLLABORATORS EXCEL
function donwloadTemplateCollaborators(url) {
  location.replace(url)
}
function getStatusCollaboratorExistExport(status) {
  return status
}
export function getTemplateSegmentsCollaboratorsApi(isTemplate) {
  const template = isTemplate ? "/template" : ""
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments/export${template}`,
  })
}

function getTemplateSegmentsCollaboratorsApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments/export/template/progress`,
  })
}
export function* getTemplateSegmentsCollaboratorsWatcher(action) {
  // const listCollaborator = yield call(getCollaboratorsApi)

  try {
    yield call(
      messageProgress,
      action.payload ? "Descargando archivo" : "Descargando archivo"
    )

    yield call(getTemplateSegmentsCollaboratorsApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateSegmentsCollaboratorsApiProgress)
      if (data.status === 200) {
        break
      }
    }
    yield call(donwloadTemplateCollaborators, data.data.data.result[0].url)
    yield call(messageDestroy)

    yield call(
      messageSuccess,
      action.payload
        ? getStatusCollaboratorExistExport("Archivo descargado")
        : getStatusCollaboratorExistExport("Archivo descargado")
    )

    yield put(getTemplateSegmentCollaboratorsSuccess())
  } catch (error) {
    yield call(messageDestroy)

    yield call(
      messageFailed,
      action.payload
        ? getStatusCollaboratorExistExport("Error al descargar el archivo")
        : getStatusCollaboratorExistExport("Error al descargar archivo")
    )

    yield put(getTemplateSegmentCollaboratorsFailed())
  }
}

// UPLOAD SEGMENT COLLABORATORS EXCEL
function uploadTemplateSegmentCollaborators(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }segments/${LOCAL_COMPANY_ID()}/employees/import`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

/* function uploadTemplateCollaboratorsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
} */

export function* uploadTemplateSegmentCollaboratorsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(
      uploadTemplateSegmentCollaborators,
      action.payload
    )
    yield call(messageDestroy)
    if (
      data_response.data.message === "Empty file" ||
      data_response.data.success === false
    ) {
      yield call(messageFailed, "El archivo está vacío.")
      yield put(uploadTemplateSegmentCollaboratorsFailed())
    } else {
      yield call(messageSuccess, "Colaboradores importados")
      yield put(uploadTemplateSegmentCollaboratorsSuccess(data_response.data))
      // yield put(push("/organization/collaborators/summary"))
    }
  } catch (error) {
    yield put(uploadTemplateSegmentCollaboratorsFailed(error))
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}
export default function* segmentsSaga() {
  yield takeLatest(GET_VARIABLES_WATCHER, getVariablesSaga)
  yield takeLatest(GET_GROUPS_WATCHER, getGroupsSaga)
  yield takeLatest(CREATE_SEGMENT_WATCHER, createSegmentSaga)
  yield takeLatest(UPDATE_SEGMENT_WATCHER, updateSegmentSaga)
  yield takeLatest(DELETE_SEGMENT_WATCHER, deleteSegmentSaga)
  yield takeLatest(GET_SEGMENTS_WATCHER, getSegmentsSaga)
  yield takeLatest(
    GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
    getTemplateSegmentsCollaboratorsWatcher
  )
  yield takeLatest(
    UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER,
    uploadTemplateSegmentCollaboratorsWatcher
  )
}
